import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { BarbershopProvider } from "./providers/useProvider.jsx";
import Home from "./pages/home/home.jsx";
import Appointment from "./pages/appointment/appointment.jsx";
import MyAppointments from "./pages/my-appointments/my-appointments.jsx";
import { AuthStateProvider } from "./providers/AuthStateProvider.jsx"; // Import your new provider
import Login from "./pages/login/login.jsx";
import Register from "./pages/login/register.jsx";
import ForgetPassword from "./pages/login/forget-password.jsx";
import ResetPassword from "./pages/login/reset-password.jsx";

import AppointmentSummary from "./pages/appointmentSummary/appointmentSummary.jsx";
import CancelAppointment from "./pages/canecllation-appointment/cancellation-appointment.jsx";
import PrivateRoutes from "./PrivateRoutes.jsx";
import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  const [configLoaded, setConfigLoaded] = useState(false);
  const host = window.location.hostname; // e.g. fade.barberflow.com
  const parts = host.split(".");
  const subdomain = parts.length > 2 ? parts[0] : null;
  // Optionally fetch config here
  useEffect(() => {
    // simulate async loading (optional)
    setTimeout(() => setConfigLoaded(true), 500);
  }, [subdomain]);

  if (!configLoaded) return <div>Loading barbershop...</div>;

  return (
    <Router>
      <BarbershopProvider barbershopName={subdomain}>
        <AuthStateProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/cancel-appointment" element={<CancelAppointment />} />

            <Route path="/" element={<Home />}>
              <Route index element={<Appointment />} />

              <Route element={<PrivateRoutes />}>
                <Route
                  path="/:bookingId/appointment-summary/"
                  element={<AppointmentSummary />}
                />
                <Route path="/my-appointments" element={<MyAppointments />} />
              </Route>
              {/* <Route path="/my-Appointments/" element={<MyAppointments />} /> */}
            </Route>
          </Routes>
        </AuthStateProvider>
      </BarbershopProvider>{" "}
    </Router>
  );
}

export default App;
